import withAxios from '../utils/with-axios';
import { urls } from '../config';
import { prop } from 'ramda';
// import getCursorPaginationParams from '../utils/getCursorPaginationParams';

/**
 * Create a pro forma invoice from draft order
 * @param {Object} [$axios=axios] Axios instance.
 * @param {Object} order Draft order data object
 * @returns {Promise} Unresolved Promise from the API.
 */
function createProForma($axios, order) {
  if (!order) {
    throw new Error('Prop {order} is required in `proForma.createProForma`');
  }
  return $axios.post(urls.apiV2("/pro-forma-invoices"), order).then(prop('data'));
}

/**
 * Get a pro forma invoice by ID
 * *
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id id of proforma to reference
 * @returns {Promise} Unresolved Promise from the API.
 */
function getProFormaById($axios, id) {
  if (!id) {
    throw new Error('Prop `id` is required in `proForma.getProFormaById`');
  }
  return $axios.get(urls.apiV2("/pro-forma-invoices/".concat(id))).then(prop('data'));
}

/**
 * Updates notes for a proForma
 *
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id Invoice ID to update
 * @param {Object} data Data object to update the invoice
 * @returns {Promise} Unresolved Promise from the API.
 */
function updateProForma($axios, id, data) {
  if (!id) {
    throw new Error('Prop `id` is required in `proForma.updateProForma`');
  }
  if (!data) {
    throw new Error('Prop `data` is required in `proForma.updateProForma`');
  }
  return $axios.patch(urls.apiV2("/pro-forma-invoices/".concat(id)), data).then(prop('data'));
}

/**
 * Fetch a pro forma invoice by order ID.
 *
 * @param {Object} $axios [$axios=axios] Axios instance.
 * @param {String} orderId
 * @returns {Promise} Unresolved Promise from the API.
 */
function getProFormaByOrderId($axios, orderId) {
  if (!orderId) {
    throw new Error('Prop `orderId` is required in `proForma.getProFormaByOrderId`');
  }
  return $axios.get(urls.apiV2("/orders/".concat(orderId, "/pro-forma-invoice"))).then(prop('data'));
}
export default {
  updateProForma: withAxios(updateProForma),
  createProForma: withAxios(createProForma),
  getProFormaById: withAxios(getProFormaById),
  getProFormaByOrderId: withAxios(getProFormaByOrderId)
};